import { Component, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { PatrolTemplateDetailComponent } from './patrol-template-detail/patrol-template-detail.component';
import { PatrolTemplateService } from '../service/patrol-template.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthState } from '../store/authInfo/auth-state';
import { Store } from '@ngxs/store';
import { PatrolControlPreviewComponent } from './patrol-control-preview/patrol-control-preview.component';
@Component({
  selector: 'app-patrol-template-management',
  templateUrl: './patrol-template-management.component.html',
  styleUrls: ['./patrol-template-management.component.less']
})
export class PatrolTemplateManagementComponent implements OnInit {

  pageIndex: number = 0 ;
  pageSize: number = 10;
  total = 0;
  loading = true;
  // 查询结果
  data = [];
  validateForm!: FormGroup;
  authState: any = null;
  checked = false;
  indeterminate = false;
  setOfCheckedId = new Set<number>();
  constructor(
    public modalService: NzModalService,
    public message: NzMessageService,
    public patrolTemplateService: PatrolTemplateService,
    public fb: FormBuilder,
    public store: Store,
  ) { }

  ngOnInit(): void {
    this.authState = this.store.selectSnapshot<any[]>(AuthState);
    this.validateForm = this.fb.group({
      ptName: [null], // 模板名称
    });
    this.queryTemplateData(1);
  }
  onAllChecked(checked: boolean): void {
    this.data.forEach((item: any) => this.updateCheckedSet(item.ptNo, checked));
    this.refreshCheckedStatus();
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  refreshCheckedStatus(): void {
    this.checked = this.data.every((item: any) => this.setOfCheckedId.has(item.ptNo));
    this.indeterminate = this.data.some((item: any) => this.setOfCheckedId.has(item.ptNo)) && !this.checked;
  }
  addTemplate(){
    const modal = this.modalService.create({
      nzTitle: '巡检模板',
      nzContent: PatrolTemplateDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 700,
      nzOnOk: (ev) => {
        // const  form  = ev.getForm();
        // if (!this.validateFormData(form)){
        //   this.message.warning('工单数据未验证通过');
        //   return false;
        // }else{

        // }
        const  templateForm  = ev.getTemplateForm();
        if (!this.validateFormData(templateForm)){
          this.message.warning('工单数据未验证通过');
          return false;
        }else{
          const questions = ev.getQuestions();
          const  template = {
            ptName : templateForm.value.ptName,
            typeNo: templateForm.value.typeNo,
            desc: templateForm.value.desc,
            createBy: this.authState.userInfo.userId,
            controls: questions
          };
          this.patrolTemplateService.addTemplate(template).subscribe((data: any) => {
            if (data > 0){
              this.queryTemplateData(1);
              this.message.success('创建成功');
              modal.close();
            }
          });
          return false;
        }
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  // 删除模板
  deleteTemplate(){
    this.modalService.confirm({
      nzTitle: '删除',
      nzContent: '你确定要删除选中模板?',
      nzOkText: '确定',
      nzCancelText: '取消',
      nzOnOk: () => {
        this.patrolTemplateService.batchDeleteTemplates(this.setOfCheckedId).subscribe((data: any) => {
          if (data > 0){
            this.message.success('删除成功！');
            this.queryTemplateData(1);
          }
        });
      }
    });
  }
  // 预览表单
  previewTemplate(ptNo: any){
    this.patrolTemplateService.getControlsByPtno(ptNo).subscribe((data: any) => {
      const modal = this.modalService.create({
        nzTitle: '巡检模板预览',
        nzContent: PatrolControlPreviewComponent,
        nzStyle: { top: '20px' },
        nzWidth: 400,
        nzComponentParams: {
          controls: data,
        },
        nzOkText: '关闭',
        nzCancelText: null,
        nzOnOk: (ev) => {
        }
      });
    });
  }
  // 编辑模板
  editTemplate(ptNo: any){
    this.patrolTemplateService.getPatrolTemplatesByPtno(ptNo).subscribe((data: any) => {
      const modal = this.modalService.create({
          nzTitle: '巡检模板' + ptNo,
          nzContent: PatrolTemplateDetailComponent,
          nzStyle: { top: '20px' },
          nzWidth: 700,
          nzComponentParams: {
              patrolTemplate: data,
          },
          nzOnOk: (ev) => {
            const  templateForm  = ev.getTemplateForm();
            if (!this.validateFormData(templateForm)){
              this.message.warning('数据未验证通过');
              return false;
            }else{
              this.modalService.confirm({
                nzTitle: '修改',
                nzContent: '你确定要修改模板?',
                nzOkText: '确定',
                nzCancelText: '取消',
                nzOnOk: () => {
                  const questions = ev.getQuestions();
                  const  template = {
                    ptNo,
                    ptName : templateForm.value.ptName,
                    typeNo: templateForm.value.typeNo,
                    desc: templateForm.value.desc,
                    updateBy: this.authState.userInfo.userId,
                    controls: questions
                  };
                  // tslint:disable-next-line:no-shadowed-variable
                  this.patrolTemplateService.updatePatrolTemplate(template).subscribe((data: any) => {
                    if (data.code === 200){
                      this.queryTemplateData(1);
                      this.message.success('修改成功');
                      modal.close();
                    }
                  });
                }
              });
              return false;
            }
          },
          nzOnCancel: (ev) => {
          }
        });
    });
  }
  // 提交表单
  submitForm() {
    this.queryTemplateData(1);
  }
  // 重置表单
  resetForm() {
    this.validateForm.reset();
    this.queryTemplateData(1);
  }
  onPageIndexChange(pageIndex: number){
    this.pageIndex = pageIndex;
    this.queryTemplateData(2);
  }
  /**
   * 查询模板数据
   * @param flag 1表示点击搜索按钮，2表示翻页
   */
   queryTemplateData(flag: number) {
    if (flag === 1){
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    // tslint:disable-next-line:max-line-length
    this.patrolTemplateService.getPatrolTemplatesByCondition(this.validateForm.value, this.pageIndex, this.pageSize).subscribe((data: any) => {
      this.loading = false;
      this.data = data.list;
      this.total = data.total;
    });
  }
  public validateFormData(validateForm: any) {
    // tslint:disable-next-line:forin
    for (const i in validateForm.controls) {
      validateForm.controls[i].markAsDirty();
      validateForm.controls[i].updateValueAndValidity();
    }
    return validateForm.valid;
  }
}
